export * from './enrollment-status.enum';
export * from './local-storage-key.enum';
export * from './permission.enum';
export * from './role.enum';
export * from './sales-workflow-steps.enum'
export * from './external-site.enum'
export * from './category.enum'
export * from './geolocation-status.enum'
export * from './navigator-permission-status.enum'
export * from './store-type.enum'
export * from './request-status.enum'
export * from './traffic-source.enum'
export * from './otp-types.enum'
export * from './phone-platform.enum'
export * from './country-code.enum'

export function toOptionArray(s: any){
  let resultArray = Object.keys(s).map(index => {
    return { value: index, label: s[index]};
  });
  return resultArray;
}
